import { IntegrationType } from './integration'
import propstackLogo from 'assets/img/integrations/propstack_logo.svg'

/** Static display metadata for integration types (BE doesn't return these) */
export interface IntegrationMetadata {
  type: IntegrationType
  name: string
  description: string
  logoUrl: string
}

export const INTEGRATION_METADATA: Record<IntegrationType, IntegrationMetadata> = {
  [IntegrationType.PROPSTACK]: {
    type: IntegrationType.PROPSTACK,
    name: 'integrations:metadata.propstack.name',
    description: 'integrations:metadata.propstack.description',
    logoUrl: propstackLogo,
  }
}

export const ALL_INTEGRATION_TYPES: IntegrationType[] = Object.values(IntegrationType)
